export const randomNumber = (): number => {
    const crypto: Crypto = window.crypto;
    const array = new Uint32Array(1);

    crypto.getRandomValues(array);
    const number: number = array[0];

    return (number);
}
